// extracted by mini-css-extract-plugin
export default {"dataItem":"styles-module_dataItem-xE8iG","inline":"styles-module_inline-IkLwk","divider":"styles-module_divider-lIQ8N"};